import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function CancellationPolicy() {
  return (
    <div className="min-h-screen flex flex-col bg-background" data-testid="cancellation-page">
      <Header />
      <main className="flex-1">
        <section className="bg-primary text-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 py-12 md:py-14">
            <p className="text-accent text-sm font-semibold tracking-wider uppercase mb-3">Legal</p>
            <h1 className="font-display text-4xl md:text-5xl font-bold">Cancellation Policy</h1>
            <p className="text-white/70 mt-3 text-sm">Last updated: January 2026</p>
          </div>
        </section>

        <article className="max-w-4xl mx-auto px-4 sm:px-6 py-10 md:py-14 prose prose-slate max-w-none">
          <p className="text-ink/80 leading-relaxed">
            You are always in control of what you post on The Pataudi. This policy explains what happens when you cancel a listing or a paid plan.
          </p>

          <h2 className="font-display text-2xl font-bold text-ink mt-8 mb-3">1. Cancelling a free listing</h2>
          <ul className="list-disc pl-6 text-ink/80 space-y-1.5">
            <li>Go to <em>Dashboard → My Listings</em> and click <strong>Delete</strong> or <strong>Mark as Sold</strong>.</li>
            <li>The listing disappears from public search within a minute. There is no fee for cancelling a free listing.</li>
          </ul>

          <h2 className="font-display text-2xl font-bold text-ink mt-8 mb-3">2. Cancelling a subscription plan</h2>
          <ul className="list-disc pl-6 text-ink/80 space-y-1.5">
            <li>Users can cancel their subscription at any time from <em>Dashboard → Transactions</em>.</li>
            <li>Cancellation stops any future billing but <strong>does not guarantee a refund</strong> — see our <a href="/refund" className="text-primary underline">Refund Policy</a>.</li>
            <li>Access to paid features (unused buyer credits, remaining seller listing quota) continues until fully consumed.</li>
          </ul>

          <h2 className="font-display text-2xl font-bold text-ink mt-8 mb-3">3. Verified Seller Badge cancellation</h2>
          <p className="text-ink/80 leading-relaxed">The Verified Seller Badge (₹249) is a one-time lifetime add-on and cannot be cancelled or refunded once purchased. It remains active on your account for the lifetime of your account.</p>

          <h2 className="font-display text-2xl font-bold text-ink mt-8 mb-3">4. Cancellation by us</h2>
          <p className="text-ink/80 leading-relaxed">We may cancel or remove a listing (with a note explaining why) when it:</p>
          <ul className="list-disc pl-6 text-ink/80 space-y-1.5 mt-2">
            <li>Belongs to a banned category (weapons, adult services, wildlife, counterfeit goods, illegal substances, etc.).</li>
            <li>Uses fake photos, stolen photos, or misleading pricing.</li>
            <li>Puts a QR / UPI code inside the listing image to bypass our unlock flow.</li>
            <li>Repeatedly duplicates the same offer across categories or cities.</li>
          </ul>

          <h2 className="font-display text-2xl font-bold text-ink mt-8 mb-3">5. Deleting your account</h2>
          <p className="text-ink/80 leading-relaxed">You can request a full account cancellation by writing to <a href="mailto:sales@thepataudi.com" className="text-primary underline">sales@thepataudi.com</a> from your registered email. Deletion is permanent — your listings, credits and transaction history are removed after a short 7-day grace window that lets you undo the request.</p>

          <h2 className="font-display text-2xl font-bold text-ink mt-8 mb-3">6. Need help?</h2>
          <p className="text-ink/80 leading-relaxed">Reach us on <a href="tel:9467458749" className="text-primary underline">+91 9467458749</a> or via <a href="https://wa.me/919467458749" target="_blank" rel="noopener noreferrer" className="text-primary underline">WhatsApp</a>. We answer between 9 AM and 9 PM IST, every day of the week.</p>
        </article>
      </main>
      <Footer />
    </div>
  );
}
